import * as React from 'react';

import { default as MuiTypography, TypographyProps as MuiTypographyProps } from '@material-ui/core/Typography';

import clsx from 'clsx';
import { useStyles } from './Typography.styles';

export type TextType = 'button' | 'title' | 'subtitle' | 'text' | 'label' | 'hint' | 'smallText' | 'large';

export type TextColor = 'black' | 'white' | 'grey';

type CustomTypographyProps = {
  textType?: TextType;
  textColor?: TextColor;
  fontWeight?: number;
};

type TypographyProps = MuiTypographyProps & CustomTypographyProps;

const Typography: React.FC<TypographyProps> = ({ children, className, textType, textColor, fontWeight, ...rest }) => {
  const styles = useStyles({
    textType,
    textColor,
    fontWeight,
  });

  return (
    <MuiTypography className={clsx(styles.root, className)} {...rest}>
      {children}
    </MuiTypography>
  );
};

export default Typography;
